import { useEffect, useState } from "react";
import { Instagram, Youtube, Music2, Mail, Facebook } from "lucide-react";
import { api } from "@/lib/api";
import { AlienLogo } from "@/components/AlienLogo";

export const Footer = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/site-config").then(({ data }) => setCfg(data)).catch(() => setCfg({}));
  }, []);

  return (
    <footer className="relative z-10 border-t border-white/10 bg-[color:var(--bg-void)] px-5 md:px-10 py-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col md:flex-row items-center md:items-end gap-6 text-center md:text-left" data-testid="footer-brand">
          {cfg && (
            <img
              src={cfg.footer_logo_url || "https://customer-assets-jt897jd0.emergentagent.net/job_noise-preview/artifacts/snkwemln_ALIEN-TMN_SPECIAL_BLACK.webp"}
              alt="Too Much Noise alien logo"
              loading="lazy"
              decoding="async"
              className="w-32 md:w-40 shrink-0 rotate-[-6deg] drop-shadow-[0_8px_20px_rgba(0,0,0,0.6)]"
              data-testid="footer-alien-logo"
            />
          )}
          <div>
            <p className="font-display text-4xl md:text-5xl leading-none tracking-widest">
              {(cfg?.footer_tagline || "SORRY\nFOR THE\nNOISE").split(/\r?\n/).map((line, i, arr) => {
                const isLast = i === arr.length - 1;
                return (
                  <span key={i}>
                    {isLast ? <span className="text-[color:var(--alien)]">{line}</span> : line}
                    {!isLast && <br />}
                  </span>
                );
              })}
            </p>
            <p className="text-white/40 text-xs uppercase tracking-[0.3em] mt-4">Too Much Noise · Verona</p>
          </div>
        </div>

        <div>
          <h4 className="font-display text-xl tracking-widest text-[color:var(--alien)] mb-5">CONTATTI</h4>
          <div className="flex gap-4 mb-4">
            <a href={cfg?.instagram_url || "#"} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="text-white/70 hover:text-[color:var(--alien)]"><Instagram size={22} /></a>
            <a href={cfg?.spotify_url || "#"} target="_blank" rel="noreferrer" aria-label="Spotify" data-testid="footer-social-spotify" className="text-white/70 hover:text-[color:var(--alien)]"><Music2 size={22} /></a>
            <a href={cfg?.youtube_url || "#"} target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="footer-social-youtube" className="text-white/70 hover:text-[color:var(--alien)]"><Youtube size={22} /></a>
            <a href={cfg?.facebook_url || "#"} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-social-facebook" className="text-white/70 hover:text-[color:var(--alien)]"><Facebook size={22} /></a>
          </div>
          <a href={`mailto:${cfg?.contact_email || "info@toomuchnoise.it"}`} className="inline-flex items-center gap-2 text-white/70 hover:text-[color:var(--alien)] text-sm" data-testid="footer-contact-email">
            <Mail size={16} /> {cfg?.contact_email || "info@toomuchnoise.it"}
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
        <span>© {new Date().getFullYear()} Too Much Noise — Tutti i diritti riservati.</span>
        <a href="/admin" data-testid="footer-admin-link" className="hover:text-white/70">Admin</a>
      </div>
    </footer>
  );
};
